var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "b-row",
    [
      _vm.perks
        ? _c("b-col", { attrs: { cols: "12" } }, [
            _c(
              "ul",
              { staticClass: "details-list perks-list my-0 text-left" },
              _vm._l(_vm.plan.perks, function (perk, pIndex) {
                return _c(
                  "li",
                  { key: pIndex, staticClass: "mb-1" },
                  [
                    _c("icon", {
                      attrs: {
                        name: "check-circle",
                        "icon-class": "text-primary mr-1",
                      },
                    }),
                    _vm._v("\n        " + _vm._s(perk) + "\n      "),
                  ],
                  1
                )
              }),
              0
            ),
          ])
        : _vm._e(),
      _vm._v(" "),
      _vm.missingPerks
        ? _c("b-col", { attrs: { cols: "12" } }, [
            _vm.plan.missingPerks
              ? _c(
                  "ul",
                  { staticClass: "details-list perks-list my-0 text-left" },
                  _vm._l(_vm.plan.missingPerks, function (perk, pIndex) {
                    return _c(
                      "li",
                      { key: pIndex, staticClass: "text-gray mb-1" },
                      [
                        _c("icon", {
                          attrs: {
                            name: "minus-circle",
                            "icon-class": "text-light-gray mr-1",
                          },
                        }),
                        _vm._v("\n        " + _vm._s(perk) + "\n      "),
                      ],
                      1
                    )
                  }),
                  0
                )
              : _vm._e(),
          ])
        : _vm._e(),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }